import PropTypes from 'prop-types';
import { motion } from 'motion/react';

import { Flex } from '../grid';

const ActiveDot = ({ color }) => {
  return (
    <Flex position="relative" alignItems="center" justifyContent="center" width="12px" height="12px">
      {/* Pulsing ring */}
      <motion.div
        style={{
          borderRadius: '50%',
          height: '6px',
          width: '6px',
          background: color,
          position: 'absolute',
          left: '3px',
          top: '3px',
        }}
        animate={{
          scale: [1, 2.5],
          opacity: [0, 0.6, 0.3, 0],
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeOut',
        }}
      />

      {/* Center circle */}
      <Flex
        style={{
          width: '6px',
          height: '6px',
          backgroundColor: color,
          borderRadius: '50%',
        }}
      />
    </Flex>
  );
};

ActiveDot.propTypes = {
  color: PropTypes.string.isRequired,
};

export { ActiveDot };
